import { render, staticRenderFns } from "./Undertaking.vue?vue&type=template&id=5f422cd6&"
import script from "./Undertaking.vue?vue&type=script&lang=js&"
export * from "./Undertaking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports